// extracted by mini-css-extract-plugin
export default {"layout":"MobileLayout_layout__o0E28","mockup":"MobileLayout_mockup__mdQKJ","image":"MobileLayout_image__CAUKC"};